import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Presentation from './Presentation';
import Webdevelopment from './Webdevelopment';
import Infographic from './Infographic';
// import Catalog from './Catalog';
import MotionGraphics from './MotionGraphics';
import {Helmet} from "react-helmet";

const Portfolio = () => {
    return (

        <div className="p-6 sm:ml-48 bg-gray-900">
        <Helmet>
        <title>My work</title>
        <meta name='portfolio' content='Mahabuba akter morsana - Portfolio' />
        </Helmet>
        <h1 className='my-4 mx-auto text-[#976DB2] font-bold lg:text-2xl sm:text-xl md:text-2xl'>View Some of My Recent Work</h1>
        <Tabs>
            <TabList className="text-gray-200 mb-14">
            <Tab>Website Development</Tab>
            <Tab>Presentation</Tab>
            <Tab>Infographics</Tab>
            {/* <Tab>Catalogue</Tab> */}
            <Tab>Motion Graphic</Tab>
            </TabList>

            <TabPanel>
            <Webdevelopment></Webdevelopment>
            </TabPanel>
            <TabPanel>
            <Presentation></Presentation>
            </TabPanel>
            <TabPanel>
            <Infographic></Infographic>
            </TabPanel>
            {/* <TabPanel>
            <Catalog></Catalog>
            </TabPanel> */}
            <TabPanel>
            <MotionGraphics></MotionGraphics>
            </TabPanel>
        </Tabs>
        </div>

    );
};

export default Portfolio;